module.exports = __webpack_public_path__ + "static/media/profil_picture.40266b18.png";